/* v8 ignore start */
import { RouterProvider } from 'react-router-dom';
import { ErrorBoundary } from '@datadog/browser-rum-react';
import { createBrowserRouter } from '@datadog/browser-rum-react/react-router-v6';
import { Provider as TooltipProvider } from '@radix-ui/react-tooltip';
import Loading from 'routes/Loading';
import routes from 'routes/route-map';
import 'App.css';

/**
 * Root node of the application
 *
 * this is the place to add providers and other global components
 */
export default function App() {
  const router = createBrowserRouter(routes);

  return (
    <ErrorBoundary>
      <TooltipProvider delayDuration={300}>
        <RouterProvider router={router} fallbackElement={<Loading />} />
      </TooltipProvider>
    </ErrorBoundary>
  );
}
